"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAttribution = exports.readAttribution = void 0;
var solid_ui_1 = require("solid-ui");
var rdflib_1 = require("rdflib");
/**
 * Constructs an attribution object for the node the subject is attributed to.
 */
function readAttribution(subject, store) {
    var attributedTo = store.any(subject, solid_ui_1.ns.as("attributedTo"));
    return read(attributedTo, store);
}
exports.readAttribution = readAttribution;
function containsPersonType(types) {
    var as = solid_ui_1.ns.as("Person").uri;
    var foaf = solid_ui_1.ns.foaf("Person").uri;
    var vcard = solid_ui_1.ns.vcard("Individual").uri;
    var schema = solid_ui_1.ns.schema("Person").uri;
    return types[as] || types[foaf] || types[vcard] || types[schema];
}
/**
 * Constructs an attribution object for the given node with data read from the store
 */
function read(attributedTo, store) {
    if (attributedTo instanceof rdflib_1.NamedNode) {
        var types = store.findTypeURIs(attributedTo);
        if (containsPersonType(types)) {
            return readPerson(store, attributedTo);
        }
        else {
            return {
                discriminator: "LinkAttribution",
                uri: attributedTo.uri,
            };
        }
    }
    return {
        discriminator: "NoAttribution",
    };
}
function readPerson(store, attributedTo) {
    var name = store.anyValue(attributedTo, solid_ui_1.ns.as("name")) ||
        store.anyValue(attributedTo, solid_ui_1.ns.foaf("name")) ||
        store.anyValue(attributedTo, solid_ui_1.ns.vcard("fn")) ||
        store.anyValue(attributedTo, solid_ui_1.ns.schema("name")) ||
        "";
    var imageSrc = readImageSrc(store, attributedTo);
    return {
        discriminator: "PersonAttribution",
        webId: attributedTo.uri,
        name: name,
        imageSrc: imageSrc,
    };
}
function readImageSrc(store, attributedTo) {
    var image = store.anyValue(attributedTo, solid_ui_1.ns.as("image"));
    if (image) {
        return store.anyValue((0, rdflib_1.sym)(image), solid_ui_1.ns.as("url")) || undefined;
    }
    return (store.anyValue(attributedTo, solid_ui_1.ns.foaf("img")) ||
        store.anyValue(attributedTo, solid_ui_1.ns.vcard("hasPhoto")) ||
        undefined);
}
/**
 * Fetches the given attribution uri and returns an updated attribution with data from the fetched resource
 */
function fetchAttribution(attribution, store) {
    return __awaiter(this, void 0, void 0, function () {
        var attributionNode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    attributionNode = (0, rdflib_1.sym)(attribution.uri);
                    return [4 /*yield*/, store.fetcher.load(attributionNode)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, read(attributionNode, store)];
            }
        });
    });
}
exports.fetchAttribution = fetchAttribution;
//# sourceMappingURL=attribution.js.map